import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '#src/atoms/buttons/Button/index.tsx';
import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { iconClock } from '#src/atoms/icons/system/iconClock.ts';
import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { HeadlineL, LabelM } from '#src/atoms/typography/index.tsx';
import { glossary } from '#src/lib/glossary.ts';

const Content = styled(Vertical).attrs({ gap: 2 })`
  align-items: flex-start;
  height: 100%;
`;

const Actions = styled(Vertical).attrs({ gap: 0 })`
  flex-grow: 1;
  width: 100%;
  justify-content: flex-end;
`;
export const Review = ({ onClick }: { onClick: () => void }) => {
  return (
    <Content>
      <FontAwesomeIcon size="2xl" icon={iconClock} />
      <HeadlineL as="h3">
        <FormattedMessage defaultMessage="We’re reviewing your ID" />
      </HeadlineL>
      <LabelM>
        <FormattedMessage defaultMessage="It usually takes 5 - 10 minutes but sometimes can take up to 24 hours." />
      </LabelM>
      <LabelM>
        <FormattedMessage defaultMessage="We’ll notify you once we validate your ID. After that, you will have access to cash deposits, cash withdrawals, and cash rewards." />
      </LabelM>
      <LabelM>
        <FormattedMessage defaultMessage="In the meantime, you can pick up right where you left off." />
      </LabelM>
      <Actions>
        <Button fullWidth size="medium" color="primary" onClick={onClick}>
          <FormattedMessage {...glossary.done} />
        </Button>
      </Actions>
    </Content>
  );
};
